const initialState = {
  myRequests: [],
  inboxRequests: [],
  loadingMyRequests: false,
  loadingInboxRequests: false,
  errorsMyRequests: null,
  errorsInboxRequests: null,
  // TODO(APP-54): Used by Escalation.js while the inbox-action API request is pending.
  // The API path will be confirmed when that endpoint is implemented.
  submittingInboxRequestAction: false,
  errorsInboxRequestAction: null,
};

const requestReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_MY_REQUESTS_PENDING":
      return { ...state, loadingMyRequests: true, errorsMyRequests: null };

    case "FETCH_MY_REQUESTS_FULFILLED":
      return {
        ...state,
        loadingMyRequests: false,
        myRequests: action.payload,
        errorsMyRequests: null,
      };

    case "FETCH_MY_REQUESTS_REJECTED":
      return {
        ...state,
        loadingMyRequests: false,
        errorsMyRequests: action.payload,
      };

    // TODO(APP-56): Optimistic entries live in Redux memory only —
    // a page refresh loses them. Once the backend is implemented,
    // submissions persist server-side. For dev-time refresh persistence,
    // consider a localStorage mirror (to be removed once the API is stable).
    case "CREATE_MY_REQUEST_OPTIMISTIC":
      return {
        ...state,
        myRequests: [action.payload, ...(state.myRequests || [])],
      };

    case "UPDATE_MY_REQUEST_OPTIMISTIC":
      return {
        ...state,
        myRequests: (state.myRequests || []).map((r) =>
          String(r.id) === String(action.payload.id) ? action.payload : r
        ),
      };

    case "DELETE_MY_REQUEST_OPTIMISTIC":
      return {
        ...state,
        myRequests: (state.myRequests || []).filter(
          (request) => String(request.id) !== String(action.payload)
        ),
      };

    case "FETCH_INBOX_REQUESTS_PENDING":
      return { ...state, loadingInboxRequests: true, errorsInboxRequests: null };

    case "FETCH_INBOX_REQUESTS_FULFILLED":
      return {
        ...state,
        loadingInboxRequests: false,
        inboxRequests: action.payload,
        errorsInboxRequests: null,
      };

    case "FETCH_INBOX_REQUESTS_REJECTED":
      return {
        ...state,
        loadingInboxRequests: false,
        errorsInboxRequests: action.payload,
      };

    case "SUBMIT_INBOX_REQUEST_ACTION_PENDING":
      return { ...state, submittingInboxRequestAction: true, errorsInboxRequestAction: null };

    case "SUBMIT_INBOX_REQUEST_ACTION_FULFILLED":
      return {
        ...state,
        submittingInboxRequestAction: false,
        errorsInboxRequestAction: null,
      };

    case "SUBMIT_INBOX_REQUEST_ACTION_REJECTED":
      return {
        ...state,
        submittingInboxRequestAction: false,
        errorsInboxRequestAction: action.payload,
      };

    default:
      return state;
  }
};

export default requestReducer;
